const cigarettesPerWeek = ["1", "2-5", "6-10", "11 o más"];
export default cigarettesPerWeek;
